import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

import { useConfiguration } from '../../../hooks/Configuration';
interface IFileProps {
    fileId: string
    type?: 'WORD' | 'PDF'
    children: any
}

const getIcon = (type: IFileProps['type']) => {
    switch(type) {
        case 'WORD': return icon({ name: 'file-word' });
        case 'PDF': return icon({ name: 'file-pdf' });
        default: return icon({ name: 'file' });
    }
}

function File({ fileId, type, children }: IFileProps) {
    const configuration = useConfiguration();

    const className = ['stx-chatbot-file'];

    if (type) className.push(`stx-chatbot-file-${type.toLocaleLowerCase()}`);

    return (
        <a
            className={className.join(' ')}
            href={`${configuration?.mediaPath}${fileId}`}
            target='_blank'
            rel="noreferrer">
            <span className='stx-chatbot-file-icon'>
                <FontAwesomeIcon
                    icon={getIcon(type)}
                    size='lg' />
            </span>
            {children}
        </a>
    );
}

export default File;
